export default function SidebarWidget() {
  return (
    <div
      className="
        mx-auto mb-10 w-full max-w-60 rounded-2xl bg-gray-50 px-4 py-5 text-center dark:bg-white/[0.03]"
    >
      <h3 className="mb-2 font-semibold text-gray-900 dark:text-white">
        Welcome to WHub Nutrition Center
      </h3>
      <p className="mb-4 text-gray-500 text-xs">
        Manage all your gym, nutrition, and client operations in one place.
        Track clients, coaches, memberships, and payments efficiently.
      </p>
      <a
        href="/clients/add"
        className="flex items-center justify-center p-3 font-medium text-sm rounded-lg bg-secondary text-primary-950"
      >
        Add New Client
      </a>
    </div>
  );
}
